export const KBName = 'Agent';
export const KBNamePlural = 'Agents';